import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import axios from '../../../util/Api';
import { Button, Input, Row, Col, Select, message } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import Item from '../../../components/Form/Item';
import { updateVendorSchema } from './schema';

const Index = (props) => {
  const history = useHistory();
  const { vendor } = props;
  return (
    <Formik
      validationSchema={updateVendorSchema}
      initialValues={{
        name: vendor.name,
        code: vendor.code,
        category: vendor.category.id,
        division: vendor.division.id,
        type: vendor.type.id,
        email: vendor.email,
        phone: vendor.phone
      }}
      onSubmit={values => {
        const url = `/vendor/update?id=${vendor.id}`;
        const data = { ...values };
        axios.post(url, data).then(resp => {
          if (resp.data.success) {
            message.success("Vendor telah berhasil diperbarui");
            history.push(`/vendor/detail?id=${vendor.id}`);
          } else {
            message.error("Gagal menyimpan data vendor");
          }
        }).catch(err => {});
      }}
    >
      {(formik) => {
        return (
          <Form>
            <Item name="Nama Perusahaan">
              <Input name="name" value={formik.values.name} onChange={formik.handleChange} />
            </Item>
            <Item name="Kode Perusahaan">
              <Input name="code" value={formik.values.code} onChange={formik.handleChange} disabled />
            </Item>
            <Item name="Kategori Perusahaan">
              <Select
                name="category"
                defaultValue={formik.values.category}
                placeholder="Pilih kategori perusahaan"
                onChange={(value) => formik.setFieldValue("category", value)}
                allowClear
              >
                <Select.Option value={1}>Z</Select.Option>
                <Select.Option value={2}>Non Z</Select.Option>
                <Select.Option value={3}>PP</Select.Option>
              </Select>
            </Item>
            <Item name="Jenis Perusahaan">
              <Select
                name="type"
                defaultValue={formik.values.type}
                placeholder="Pilih jenis perusahaan"
                onChange={(value) => formik.setFieldValue("type", value)}
                allowClear
              >
                <Select.Option value={1}>Subkon</Select.Option>
                <Select.Option value={2}>Supplier</Select.Option>
                <Select.Option value={3}>Alat</Select.Option>
                <Select.Option value={4}>Lainnya</Select.Option>
                <Select.Option value={5}>PP</Select.Option>
              </Select>
            </Item>
            <Item name="Divisi Perusahaan">
              <Select
                name="division"
                defaultValue={formik.values.division}
                placeholder="Pilih divisi perusahaan"
                onChange={(value) => formik.setFieldValue("division", value)}
                allowClear
              >
                <Select.Option value={1}>EPC</Select.Option>
                <Select.Option value={2}>Gedung</Select.Option>
                <Select.Option value={3}>Infra 1</Select.Option>
                <Select.Option value={4}>Infra 2</Select.Option>
                <Select.Option value={5}>PP</Select.Option>
              </Select>
            </Item>
            <Item name="Email">
              <Input name="email" value={formik.values.email} onChange={formik.handleChange} />
            </Item>
            <Item name="Password">
              <Input type="password" name="password" value={formik.values.password} onChange={formik.handleChange} placeholder="Kosongkan jika tidak ingin mengganti password" />
            </Item>
            <Item name="Nomor Telepon/WA">
              <Input name="phone" value={formik.values.phone} onChange={formik.handleChange} />
            </Item>
            <Row>
              <Col span={6}></Col>
              <Col span={18}>
                <Button type="primary" htmlType="submit" className="gx-mb-0" loading={formik.isSubmitting}>
                  Simpan Perubahan
                </Button>
                <Link to={`/vendor/detail?id=${vendor.id}`} className="ant-btn ant-btn-secondary gx-mb-0">
                  Kembali
                </Link>
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
}

export default Index;